var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "warrantyProps container mg mg--b-4" },
    [
      _c(
        "ma-accordion",
        {
          ref: "propsAccordion",
          attrs: { expanded: !_vm.shouldCloseAccordion }
        },
        [
          _c("template", { slot: "accordionTop" }, [
            _c("p", { staticClass: "headline-medium black" }, [
              _vm._v(_vm._s(_vm.$t("warrantyProps.aboutProperty")))
            ])
          ]),
          _c("template", { slot: "accordionBottom" }, [
            _c("div", { staticClass: "grid" }, [
              _c("div", { staticClass: "grid__cell-md-2" }, [
                _c(
                  "div",
                  { staticClass: "grid" },
                  [
                    !_vm.stateUserIsReduxMode
                      ? _c("ma-input-text", {
                          attrs: {
                            type: "text",
                            name: "propsAddress",
                            col: "4",
                            value: _vm.stateWarrantyAddress,
                            icon: "ico-cp",
                            literal: _vm.$t("warrantyProps.address.literal"),
                            placeholder: _vm.$t(
                              "warrantyProps.address.placeholder"
                            )
                          },
                          on: {
                            change: function($event) {
                              ;[
                                _vm.actWarrantyUpdateProps(),
                                (_vm.stateComWarrantyAddress = $event)
                              ]
                            }
                          }
                        })
                      : _vm._e(),
                    _c("ma-input-text", {
                      attrs: {
                        value: _vm.stateWarrantyZipCode,
                        type: "text",
                        name: "propsZipCode",
                        col: "2",
                        icon: "ico-cp",
                        literal: _vm.$t("warrantyProps.zipCode.literal"),
                        disabled: ""
                      }
                    }),
                    _vm.agentView === false
                      ? _c("ma-input-radio", {
                          attrs: {
                            value: _vm.normalizedPropertyType,
                            type: "radio",
                            name: "propsPropertyType",
                            col: "2",
                            options: _vm.propertyTypeOptions,
                            literal: _vm.$t(
                              "warrantyProps.propertyType.literal"
                            )
                          },
                          on: {
                            change: $event =>
                              _vm.handleChangeOption($event, "property")
                          }
                        })
                      : _vm._e(),
                    _vm.agentView === true
                      ? _c("ma-input-btn", {
                          style: {
                            visibility:
                              _vm.userRole !== true ? "visible" : "hidden"
                          },
                          attrs: {
                            value: _vm.normalizedPropertyType,
                            type: "btn",
                            name: "propsPropertyType",
                            col: "2",
                            options: _vm.propertyTypeOptions,
                            literal: _vm.$t(
                              "warrantyProps.propertyType.literal"
                            )
                          },
                          on: {
                            change: $event =>
                              _vm.handleChangeOption($event, "property")
                          }
                        })
                      : _vm._e(),
                    _vm.agentView === false
                      ? _c("ma-input-radio", {
                          attrs: {
                            value: _vm.stateComWarrantyResidentType,
                            type: "radio",
                            name: _vm.$t("warrantyProps.residentType.name"),
                            col: "2",
                            options: _vm.residentTypeOptions,
                            literal: _vm.$t(
                              "warrantyProps.residentType.literal"
                            ),
                            disabled: ""
                          },
                          on: {
                            change: $event =>
                              _vm.handleChangeOption($event, "resident")
                          }
                        })
                      : _vm._e(),
                    _vm.agentView === true
                      ? _c("ma-input-btn", {
                          style: {
                            visibility:
                              _vm.userRole !== true ? "visible" : "hidden"
                          },
                          attrs: {
                            value: _vm.stateComWarrantyResidentType,
                            type: "btn",
                            name: _vm.$t("warrantyProps.residentType.name"),
                            col: "2",
                            options: _vm.residentTypeOptions,
                            literal: _vm.$t(
                              "warrantyProps.residentType.literal"
                            ),
                            disabled: ""
                          },
                          on: {
                            change: $event =>
                              _vm.handleChangeOption($event, "resident")
                          }
                        })
                      : _vm._e(),
                    _vm.agentView === false
                      ? _c("ma-input-radio", {
                          attrs: {
                            value: _vm.stateComWarrantyMoreThanTwoYears,
                            type: "radio",
                            name: "moreThanTwoYears",
                            col: "2",
                            options: _vm.moreThanTwoYearsOptions,
                            literal: _vm.$t(
                              "warrantyProps.moreThanTwoYears.literal"
                            ),
                            disabled: ""
                          },
                          on: {
                            change: $event =>
                              _vm.handleChangeOption($event, "moreThanTwoYears")
                          }
                        })
                      : _vm._e(),
                    _vm.agentView === true
                      ? _c("ma-input-btn", {
                          style: {
                            visibility:
                              _vm.userRole !== true ? "visible" : "hidden"
                          },
                          attrs: {
                            value: _vm.stateComWarrantyMoreThanTwoYears,
                            type: "btn",
                            name: "moreThanTwoYears",
                            col: "2",
                            options: _vm.moreThanTwoYearsOptions,
                            literal: _vm.$t(
                              "warrantyProps.moreThanTwoYears.literal"
                            ),
                            disabled: ""
                          },
                          on: {
                            change: $event =>
                              _vm.handleChangeOption($event, "moreThanTwoYears")
                          }
                        })
                      : _vm._e(),
                    _vm.stateUserIsSelfcareAdmin
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn mainBlue grid__cell-md-4 mg mg--r-2",
                            attrs: { disabled: _vm.generateLinkIsDisabled },
                            on: {
                              click: function($event) {
                                return _vm.handleOpenModal()
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("warrantyProps.buttonLink.literal"))
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.stateUserIsSelfcareAdmin
                      ? _c(
                          "ma-modal",
                          {
                            ref: "linkModal",
                            staticClass: "modal-link",
                            attrs: { type: "small" },
                            on: { "modal:close": _vm.closeLinkModal }
                          },
                          [
                            _c("template", { slot: "modalContent" }, [
                              _c("div", { staticClass: "modal__main" }, [
                                _c(
                                  "div",
                                  { staticClass: "container-content_modal" },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "black headline-large mg mg--b-4"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "warrantyProps.modalLink.title"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("ma-input-select", {
                                      attrs: {
                                        type: "select",
                                        name: "selfCareForms",
                                        col: "4",
                                        icon: "ico-dommages",
                                        literal: _vm.$t(
                                          "warrantyProps.formsList"
                                        ),
                                        options: _vm.selfcareForms,
                                        value: _vm.selfcareFormsValue
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.selfcareFormsValue = $event
                                        }
                                      }
                                    }),
                                    _c("ma-input-select", {
                                      attrs: {
                                        type: "select",
                                        name: "userType",
                                        col: "4",
                                        icon: "dossier",
                                        literal: _vm.$t(
                                          "warrantyProps.userIdsList"
                                        ),
                                        options: _vm.selfcareFlows,
                                        value: _vm.selfcareFlowsValue
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.handleSelfcareFlowsValue(
                                            $event
                                          )
                                        }
                                      }
                                    }),
                                    _c("ma-input-select", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.typeValidationSelect,
                                          expression: "!typeValidationSelect"
                                        }
                                      ],
                                      attrs: {
                                        type: "select",
                                        name: "selfCareValidationType",
                                        col: "4",
                                        icon: "dossier",
                                        literal: _vm.$t(
                                          "warrantyProps.clientValidationType"
                                        ),
                                        options:
                                          _vm.selfcareValidationTypeOptions,
                                        value: _vm.selfcareValidationTypeValue
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.selfcareValidationTypeValue = $event
                                        }
                                      }
                                    }),
                                    _c(
                                      "p",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.typeValidationSelect,
                                            expression: "typeValidationSelect"
                                          }
                                        ],
                                        staticClass:
                                          "text-small blueDark mg mg--b-2"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "warrantyProps.clientValidationType"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c("VuePhoneNumberInput", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.selfcareValidationTypeValue ===
                                            "SMS",
                                          expression:
                                            'selfcareValidationTypeValue === "SMS"'
                                        }
                                      ],
                                      ref: "phoneNumberInput",
                                      staticClass: "mg mg--b-2 mg--r-4",
                                      attrs: {
                                        name: "selfcareClientPhoneInput",
                                        "default-country-code":
                                          _vm.countryCodeSelected,
                                        placeHolder: _vm.getEncryptedPhone(),
                                        literal: _vm.$t(
                                          "warrantyProps.clientPhoneNumber"
                                        ),
                                        translations: {
                                          countrySelectorLabel: _vm.$t(
                                            "warrantyProps.countryCode"
                                          ),
                                          example: _vm.$t(
                                            "warrantyProps.example"
                                          ),
                                          phoneNumberLabel: _vm.$t(
                                            "warrantyProps.clientPhoneNumber"
                                          )
                                        }
                                      },
                                      on: {
                                        update: _vm.handleOnPhoneNumberUpdate
                                      },
                                      model: {
                                        value: _vm.selfcareClientPhone,
                                        callback: function($$v) {
                                          _vm.selfcareClientPhone = $$v
                                        },
                                        expression: "selfcareClientPhone"
                                      }
                                    }),
                                    _vm.selfcareValidationTypeValue === "EMAIL"
                                      ? _c("ma-input-text", {
                                          attrs: {
                                            name: "selfcareEmailInput",
                                            icon: "ico-others",
                                            type: "email",
                                            col: "4",
                                            literal: _vm.$t(
                                              "warrantyProps.clientEmail"
                                            )
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.handleOnEmailChange(
                                                $event
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.selfcareClientEmail,
                                            callback: function($$v) {
                                              _vm.selfcareClientEmail = $$v
                                            },
                                            expression: "selfcareClientEmail"
                                          }
                                        })
                                      : _vm._e(),
                                    !_vm.isAgentRole &&
                                    _vm.selfcareFlowsValue === `e2e`
                                      ? _c("ma-input-select", {
                                          attrs: {
                                            type: "select",
                                            name: "selfcareFnolIds",
                                            col: "4",
                                            icon: "ico-numero-police",
                                            literal: _vm.$t(
                                              "warrantyProps.fnolIdsList"
                                            ),
                                            options: _vm.selfcareFnolIds,
                                            value: _vm.selfcareFnolIdsValue
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.selfcareFnolIdsValue = $event
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn mainBlue grid__cell-md-4 mg mg--r-2 mg--t-2",
                                        attrs: {
                                          disabled:
                                            _vm.isDiabledPrimaryButton ||
                                            _vm.isExtraInfoAnswered
                                        },
                                        on: { click: _vm.handleGenerateLink }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "warrantyProps.modalLink.buttonGenerateLink"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn mainBlue cancelBtn grid__cell-md-4",
                                        on: { click: _vm.closeLinkModal }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "warrantyProps.modalLink.buttonCancel"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "container-link_selfcare grid__cell-md-4 mg mg--t-0 screen-sm-min center",
                                    class: {
                                      linkIsVisible: _vm.showLinkSelfcare
                                    }
                                  },
                                  [
                                    _c("svgicon", {
                                      attrs: {
                                        name: "pencil-edit",
                                        height: "8",
                                        widht: "14.67",
                                        color: "#005BA5"
                                      }
                                    }),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "text-medium blueDark",
                                        attrs: {
                                          target: "blank",
                                          href: _vm.linkSelfCare
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.linkSelfCare))]
                                    )
                                  ],
                                  1
                                ),
                                !_vm.stateWarrantyAnsweredExtraInfo &&
                                _vm.selfcareFlowsValue === `e2e` &&
                                _vm.stateWarrantyShowExtraInfo
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "container-content_modal__alert"
                                      },
                                      [
                                        _c("svgicon", {
                                          attrs: {
                                            name: "alert-triangle",
                                            height: "16",
                                            widht: "16",
                                            color: "#f04237"
                                          }
                                        }),
                                        _c("div", [
                                          _c(
                                            "p",
                                            { staticClass: "text-small red" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "warrantyProps.modalLink.alertMessage"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-small red alert-link",
                                              on: {
                                                click: _vm.openMoreInfoModalLink
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "warrantyProps.modalLink.alertAction"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            ])
                          ],
                          2
                        )
                      : _vm._e(),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.showMoreInfoModalBtn &&
                              _vm.checkRequiredFields(),
                            expression:
                              "showMoreInfoModalBtn && checkRequiredFields()"
                          }
                        ],
                        ref: "moreInfoModalBtn",
                        staticClass: "btn mainBlue grid__cell-md-4",
                        attrs: { disabled: _vm.generateLinkIsDisabled },
                        on: { click: _vm.openMoreInfoModalLink }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "warrantyProps.moreInfoModal.buttonGenerateLink"
                            )
                          )
                        )
                      ]
                    ),
                    _c("ma-more-info-modal", {
                      ref: "moreInfoModal",
                      on: { close: _vm.onMoreInfoModalClose }
                    })
                  ],
                  1
                )
              ]),
              !_vm.stateUserIsReduxMode
                ? _c(
                    "div",
                    { staticClass: "grid__cell-md-2" },
                    [
                      _c(
                        "transition",
                        { attrs: { name: "fade", mode: "out-in" } },
                        [
                          _c("div", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showStreetView,
                                expression: "showStreetView"
                              }
                            ],
                            attrs: { id: "warrantyProps_street-view" }
                          })
                        ]
                      ),
                      _c(
                        "transition",
                        { attrs: { name: "fade", mode: "out-in" } },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.showStreetView,
                                  expression: "!showStreetView"
                                }
                              ],
                              staticClass: "warrantyProps__image"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "warrantyProps__placeholder" },
                                [
                                  _c("svgicon", {
                                    attrs: {
                                      icon: "fence",
                                      height: "78",
                                      width: "78"
                                    }
                                  }),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-medium mg mg--b-1 mg--t-6 black"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "warrantyProps.map.empty.title"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c("p", { staticClass: "text-small black" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("warrantyProps.map.empty.text")
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }